<template>
  <!-- <div class="bg-gray-light flex items-center p-10">
    <p
      @click="goBackToSignin()"
      class="text-sm font-semibold text-gray-600 cursor-pointer"
    >
      <icon name="arrow-left" class="w-3 fill-gray-600 mr-2" />
    </p>
    <p
      @click="goBackToSignin()"
      class="text-sm font-semibold text-gray-600 cursor-pointer"
    >
      {{ $t('signin.emailResendBackButton') }}
    </p>
  </div> -->
  <div
    v-if="!loading"
    class="bg-gray-light flex flex-col items-center h-screen"
  >
    <p class="text-xl font-bold mt-24 mb-5">
      {{ $t('multiAuth.chooseAccountTitle') }}
    </p>
    <p class="text-sm text-gray-500 mb-2">
      {{ $t('multiAuth.loggedInAsTxt') }}
      <span class="font-bold text-black">{{ email }}</span>
    </p>
    <p class="text-sm text-gray-500 mb-10">
      {{ $t('multiAuth.notYouTxt') }}
      <router-link to="/signin" class="text-blue-500"
        ><span class="font-bold">{{
          $t('multiAuth.logOffTxt')
        }}</span></router-link
      >
    </p>
    <div class="w-[500px] bg-white rounded-lg shadow-2xl mx-auto px-6 py-5">
      <p class="text-lg font-bold mb-5">
        {{ $t('multiAuth.yourCommunitiesTitle') }}
      </p>
      <div class="flex flex-col gap-4 mb-4">
        <div
          v-for="option in authOptions"
          :key="option.id"
          class="flex items-center border rounded-md space-x-2 p-3 cursor-pointer"
          @click="selectOption(option)"
        >
          <img
            :src="option.profile.profileImage"
            alt=""
            class="flex-none w-12 h-12 rounded-full"
          />
          <div class="grow">
            <p class="text-sm font-bold mb-1">
              {{ option.profile.name }}
            </p>
            <p v-if="option.role === 'admin'" class="text-sm text-gray-500">
              {{ $t('multiAuth.adminTxt') }}
            </p>
            <p
              v-if="option.role === 'contributor'"
              class="text-sm text-gray-500"
            >
              {{ $t('multiAuth.contributorTxt') }}
            </p>
          </div>
          <div class="flex-none">
            <p>
              <icon
                name="chevron-left"
                class="w-4 fill-gray-500 mr-1 rotate-180"
              />
            </p>
          </div>
        </div>
        <div
          class="flex h-16 items-center justify-center border rounded-md space-x-2 p-3 cursor-pointer"
          @click="goToSignup()"
        >
          <div
            class="bg-blue-500 rounded-full w-5 h-5 flex items-center justify-center"
          >
            <icon name="plus" class="w-4 fill-white" />
          </div>
          <p class="text-blue-500 leading-none font-bold">
            {{ $t('multiAuth.createNewAccount') }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="bg-gray-light flex flex-col items-center h-screen pt-[200px]"
  >
    <Vue3Lottie
      :animationLink="require('/assets/images/loader-round.jpg')"
      :height="100"
      :width="100"
      :speed="1.5"
    />
  </div>
</template>

<script>
import { ref, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import jwt from 'jsonwebtoken';
import { useI18n } from 'vue-i18n';
import { toChecksumAddress } from 'ethereum-checksum-address';

export default {
  setup() {
    const cookies = inject('cookies');
    const router = useRouter();
    const route = useRoute();
    const { t } = useI18n();
    const api = inject('api');
    const store = inject('store');
    const utils = inject('utils');

    const { token } = route.query;
    const authOptions = ref([]);
    const email = ref(null);
    const loading = ref(true);

    if (!token) {
      router.push('/signin');
    } else {
      if (cookies.get('token')) {
        cookies.remove('token');
      }
      const { signup, isSubCommunity } = jwt.decode(token);

      if (isSubCommunity) {
        const { did } = jwt.decode(token);

        store.commit('resetIssuerState');
        store.commit(
          'setCurrentAddress',
          toChecksumAddress(utils.didToAddress(did))
        );
        store.commit('setCurrentPublicKeyBase58', did.split(':')[2]);
        cookies.set('token_tmp', token);
        store.commit('setIssuerConnectionDisplay', false);
        store.commit('setIsWeb2Connexion', true);
        store.commit('setConnexionEmail', email);
        router.push('/signup?connected=1');
        return;
      } else {
        api
          .verifyManagerMagicAuth(token)
          .then((res) => {
            if (signup) {
              const sessionToken = res.data.token;
              const { did } = jwt.decode(sessionToken);

              store.commit('resetIssuerState');
              store.commit(
                'setCurrentAddress',
                toChecksumAddress(utils.didToAddress(did))
              );
              store.commit('setCurrentPublicKeyBase58', did.split(':')[2]);
              cookies.set('token_tmp', sessionToken);
              store.commit('setIssuerConnectionDisplay', false);
              store.commit('setIsWeb2Connexion', true);
              store.commit('setConnexionEmail', email);
              router.push('/signup?connected=1');
            } else {
              authOptions.value = res.data.options;
              const { email: emailDecoded } = jwt.decode(token);
              email.value = emailDecoded;

              if (authOptions.value.length === 1) {
                selectOption(authOptions.value[0]);
              } else {
                loading.value = false;
              }
            }
          })
          .catch((err) => {
            if (err.response?.data?.message) {
              console.log(err.response?.data?.message);
              router.push('/expired');
            } else {
              utils.showToastMessageError(t('other.serverError'));
            }
          });
      }
    }

    async function selectOption(option) {
      api
        .finalizeMagicAuth(token, option.did)
        .then((res) => {
          const { token: sessionToken } = res.data;
          const decodedToken = jwt.decode(sessionToken);

          store.commit('setCurrentIssuerDid', decodedToken.did);
          store.commit(
            'setCurrentAddress',
            toChecksumAddress(utils.didToAddress(decodedToken.did))
          );
          store.commit(
            'setCurrentPublicKeyBase58',
            decodedToken.did.split(':')[2]
          );
          store.commit('setIsWeb2Connexion', decodedToken.web2);
          store.commit('setConnexionEmail', decodedToken.connexionEmail);
          store.commit('setIsAdmin', !decodedToken.isContributor);
          cookies.set('token', sessionToken);
          store.dispatch('getTemplateLists');
          store.dispatch('getIssuerInfo');
          router.push('/');
        })
        .catch((err) => {
          if (err.response?.data?.message) {
            console.log(err.response?.data?.message);
            router.push('/expired');
          } else {
            console.log(err);
            utils.showToastMessageError(t('other.serverError'));
          }
        });
    }

    function goBackToSignin() {
      cookies.remove('token');
      cookies.remove('adminToken');
      cookies.remove('adminProfile');
      store.commit('resetIssuerState');
      router.push('/signin');
    }

    function goToSignup() {
      api
        .createSignupTokenFromMultiAuth({
          connexionEmail: email.value,
          token,
        })
        .then((res) => {
          const { token: signupToken } = res.data;

          const { did, connexionEmail: signupConnexionEmail } =
            jwt.decode(signupToken);

          cookies.remove('token');
          cookies.remove('adminToken');
          cookies.remove('adminProfile');

          store.commit('resetIssuerState');
          store.commit(
            'setCurrentAddress',
            toChecksumAddress(utils.didToAddress(did))
          );
          store.commit('setCurrentPublicKeyBase58', did.split(':')[2]);
          cookies.set('token_tmp', signupToken);
          store.commit('setIssuerConnectionDisplay', false);
          store.commit('setIsWeb2Connexion', true);
          store.commit('setConnexionEmail', signupConnexionEmail);
          router.push('/signup?connected=1');
        });
    }

    return {
      authOptions,
      email,
      selectOption,
      loading,
      goBackToSignin,
      goToSignup,
    };
  },
};
</script>
